module.exports = __webpack_public_path__ + "static/media/box-open.1defb99c.svg";